import MainGridController from '../../controllers/grid/MainGridController';
import PromptController from '../../controllers/prompt/PromptController';
import { COMPONENTS } from '../../lib/constants';
import { PromptViewGrid } from './PromptViewGrid';

export const PromptView = {
	name: COMPONENTS.PROMPT,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: PromptController,
			name: 'PromptController',
			config: {
				holder: 'prompt_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'PromptGridController',
			config: PromptViewGrid
		}
	],
	components: [
		{
			name: 'prompt_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'autospin_bg',
					position: { x: 0, y: 0 }
					// alpha: 0.9,
				},
				{
					name: "bg_border",
					type: "Sprite",
					img: "mid_modal_frame",
					position: { x: -20, y: -20 },
				  },
				{
					name: 'header',
					type: 'CustomText',
					text: 'FREE_SPIN_HEADER',
					position: { x: 587 / 2 + 10, y: 15 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_TITLE',
					type: 'Text',
					text: 'PROMPT_TITLE',
					position: { x: 587 / 2, y: 75 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_DESC',
					type: 'Text',
					text: 'PROMPT_DESC',
					position: { x: 587 / 2, y: 105 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE',
					type: 'CustomText',
					text: 'PROMPT_PRIZE',
					position: { x: 587 / 2 + 10, y: 156 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE_DESC',
					type: 'Text',
					text: 'PROMPT_PRIZE_DESC',
					position: { x: 587 / 2, y: 220 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE_DISCOUNT',
					type: 'CustomText',
					text: 'PROMPT_PRIZE_DISCOUNT',
					position: { x: 587 / 2 + 10, y: 225 }
				},
				{
					name: 'PROMPT_PRIZE_DESC_1',
					type: 'Text',
					text: 'PROMPT_PRIZE_DESC_1',
					position: { x: 587 / 2, y: 150 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE_DESC_2',
					type: 'Text',
					text: 'PROMPT_PRIZE_DESC_2',
					position: { x: 587 / 2, y: 150 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_AMOUNT',
					type: 'CustomText',
					text: 'PROMPT_AMOUNT',
					position: { x: 587 / 2 + 10, y: 260 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMT_INFO',
					type: 'Text',
					text: 'PROMT_INFO',
					position: { x: 587 / 2, y: 315 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_YES',
					type: 'ActionButton',
					bg: 'external_bonus_play_now_btn',
					position: { x: 180, y: 415 }
				},
				{
					name: 'PROMPT_NO',
					type: 'ActionButton',
					bg: 'external_bonus_play_later_btn',
					position: { x: 415, y: 415 }
				}
			]
		}
	]
};
